import { render, staticRenderFns } from "./TipsCommon.vue?vue&type=template&id=befe808e&scoped=true&"
import script from "./TipsCommon.vue?vue&type=script&lang=js&"
export * from "./TipsCommon.vue?vue&type=script&lang=js&"
import style0 from "./TipsCommon.vue?vue&type=style&index=0&id=befe808e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe808e",
  null
  
)

component.options.__file = "TipsCommon.vue"
export default component.exports